import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { FiscalDataService } from '../../services/fiscal-data.service';

@Component({
	selector: 'app-read-fiscal-data',
	templateUrl: './read-fiscal-data.component.html',
	styleUrls: ['./read-fiscal-data.component.css']
})
export class ReadFiscalDataComponent implements OnInit {

	parent: any;
  customerOrSupplier: string;
	fiscalDatas: any[] = [];
	fiscalDatasSub: Subscription;

	data: Array<any>;
	rows: Array<any> = [];
	columns: Array<any> = [
		{ title: 'RFC', name: 'name', sort: 'asc' },
		{ title: 'Razón Social', name: 'businessName' },
		{ title: 'Acciones',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
				styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
				styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
	];

	page = 1;
	itemsPerPage = 10;
	maxSize = 5;
	numPages = 1;
	length = 0;
	config: any = {
		paging: true,
		sorting: { columns: this.columns },
		filtering: { filterString: '' },
		api: {
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
	};

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private fiscalDataService: FiscalDataService,
	) {

    this.parent = this.activatedRoute.parent.snapshot.paramMap.get('id');
		this.customerOrSupplier = this.activatedRoute.parent.snapshot.data['customerOrSupplier'];
		this.loadFiscalDatas();
		
	}

	ngOnInit() {
	}
	ngOnDestroy() {
		this.fiscalDatasSub.unsubscribe();
	}

	loadFiscalDatas() {
		this.fiscalDatasSub = this.fiscalDataService.getFiscalDatas(this.parent, this.customerOrSupplier).subscribe(tempFiscalDatas => {
			this.fiscalDatas = [];

			for (const idx in tempFiscalDatas) {
				this.fiscalDatas.push(tempFiscalDatas[idx]);
			}

			this.data = this.fiscalDatas;
			this.length = this.data.length;
			this.onChangeTable(this.config);
		});
	}
	addFiscalData(){
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/add_fiscalData']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/add_fiscalData']);
		}
	}

	onCellClick(data: any): any {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/vw_fiscalData/' + data.row.id]);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/vw_fiscalData/' + data.row.id]);
		}
	}

	onEdit(data: any) {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/edt_fiscalData/' + data.row.id]);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/edt_fiscalData/' + data.row.id]);
		}
	}

	onDelete(data: any) {
		this.fiscalDataService.deleteFiscalData(data.row.id);
	}

	// *************** Table functionality *************** //
	changePage(page: any, data: Array<any> = this.data): Array<any> {
		let start = (page.page - 1) * page.itemsPerPage;
		let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

		return data.slice(start, end);
	}

	changeSort(data: any, config: any): any {
		if (!config.sorting) {
			return data;
		}

		let columns = this.config.sorting.columns;
		let columnName: string;
		let sort: string;

		for (let i = 0; i < columns.length; i++) {
			if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
				columnName = columns[i].name;
				sort = columns[i].sort;
			}
		}

		if (!columnName) {
			return data;
		}

		// simple sorting
		return data.sort((previous: any, current: any) => {
			if (previous[columnName] > current[columnName]) {
				return sort === 'desc' ? -1 : 1;
			} else if (previous[columnName] < current[columnName]) {
				return sort === 'asc' ? -1 : 1;
			}

			return 0;
		});
	}

	changeFilter(data: any, config: any): any {
		let filteredData: Array<any> = data;

		this.columns.forEach((column: any) => {
			if (column.filtering) {
				filteredData = filteredData.filter((item: any) => {
					return item[column.name].match(column.filtering.filterString);
				});
			}
		});

		if (!config.filtering) {
			return filteredData;
		}

		if (config.filtering.columnName) {
			return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
		}

		let tempArray: Array<any> = [];

		filteredData.forEach((item: any) => {
			let flag = false;

			this.columns.forEach((column: any) => {
				if (item[column.name] &&
					item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
					flag = true;
				}
			});

			if (flag) {
				tempArray.push(item);
			}
		});

		filteredData = tempArray;

		return filteredData;
	}

	onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
		if (config.filtering) {
				Object.assign(this.config.filtering, config.filtering);
		}

		if (config.sorting) {
				Object.assign(this.config.sorting, config.sorting);
		}

		let filteredData = this.changeFilter(this.data, this.config);
		let sortedData = this.changeSort(filteredData, this.config);

		this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
		this.length = sortedData.length;
	}

}
